import vm from 'vue'
export default class Range {

	get [Symbol.toStringTag]() {
		return "Ranger";
	}

	constructor(mode) {
		this.mode = mode;
	}

	//默认是图片的ranger
	MODE = "pic"

	setMODE(MODE) {
		vm.set(this, "MODE", MODE);
	}

	//总区域
	n_width = NaN;
	n_height = NaN;

	setWidth(n_width) {
		if (this.MODE == "map") return;
		vm.set(this, "n_width", n_width);
	}
	setHeight(n_height) {
		if (this.MODE == "map") return;
		vm.set(this, "n_height", n_height);
	}

	//可视区域
	n_viewWidth = NaN;
	n_viewHeight = NaN;
	n_viewX = 0;
	n_viewY = 0;

	setViewWidth(n_viewWidth) {
		vm.set(this, "n_viewWidth", n_viewWidth);
	}
	setViewHeight(n_viewHeight) {
		vm.set(this, "n_viewHeight", n_viewHeight);
	}
	setViewX(n_viewX) {
		if (this.MODE == "map") return;
		vm.set(this, "n_viewX", n_viewX);
	}
	setViewY(n_viewY) {
		if (this.MODE == "map") return;
		vm.set(this, "n_viewY", n_viewY);
	}

	//mover
	o_mover = null;
	//判断范围
	get b_leftInRange() {
		if (this.MODE == "map") return true;
		return !(this.o_mover.n_left < this.n_viewX);
	}
	get b_rightInRange() {
		if (this.MODE == "map") return true;
		return !(this.o_mover.n_right > this.n_viewX + this.n_viewWidth);
	}
	get b_topInRange() {
		if (this.MODE == "map") return true;
		return !(this.o_mover.n_top < this.n_viewY);
	}
	get b_bottomInRange() {
		if (this.MODE == "map") return true;
		return !(this.o_mover.n_bottom > this.n_viewY + this.n_viewHeight);
	}
	b_moverIsInViewRange() {
		if (this.MODE == "map") return true;
		if (this.b_leftInRange && this.b_rightInRange && this.b_topInRange && this.b_bottomInRange) {
			return true;
		} else {
			if (!this.b_leftInRange) {
				// //console.log('左', this.o_mover.n_left, this.n_viewX);
				// //console.log('左边超出')
				let distance = this.n_viewX - this.o_mover.n_left;
				vm.set(this.o_mover, "n_left", this.o_mover.n_left + distance);
			}
			if (!this.b_rightInRange) {
				// //console.log('右', this.o_mover.n_right, this.n_viewX + this.n_viewWidth);
				// //console.log('右边超出')
				let distance = this.o_mover.n_right - (this.n_viewX + this.n_viewWidth);
				vm.set(this.o_mover, "n_left", this.o_mover.n_left - distance);
			}
			if (!this.b_topInRange) {
				// //console.log('上', this.o_mover.n_top, this.n_viewY);
				// //console.log('上边超出')
				vm.set(this.o_mover, "n_top", this.n_viewY);
				// //console.log(this.o_mover.n_top);
			}
			if (!this.b_bottomInRange) {
				// //console.log('下', this.o_mover.n_bottom, this.n_viewY + this.n_viewHeight);
				// //console.log('下边超出')
				this.o_mover.n_top -= this.o_mover.n_bottom - (this.n_viewY + this.n_viewHeight);
			}
			return false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/dynamicRoute1/lv2/continuing/Ranger.js